import { Link } from "react-router-dom";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { money } from "@/lib/api";
import { MapPin, TrendingUp, Clock, Users } from "lucide-react";

const FALLBACK_IMG = "https://images.unsplash.com/photo-1729006122953-e3cafd3dd875?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxLaW5zaGFzYXxlbnwwfHx8fDE3ODYzODU1NjJ8MA&ixlib=rb-4.1.0&q=85";

const sectorColors = {
  "Énergie": "bg-amber-100 text-amber-700",
  "Agriculture": "bg-green-100 text-green-700",
  "Infrastructure": "bg-blue-100 text-blue-700",
  "Mines": "bg-slate-200 text-slate-700",
  "Technologie": "bg-purple-100 text-purple-700",
  "Numérique": "bg-cyan-100 text-cyan-700",
  "Immobilier": "bg-orange-100 text-orange-700",
  "Santé": "bg-rose-100 text-rose-700",
};

function Risk({ level }) {
  let activeColor = "bg-congo-red";
  if (level <= 2) activeColor = "bg-green-500";
  else if (level <= 3) activeColor = "bg-congo-gold";
  return (
    <div className="flex items-center gap-0.5" title={`Risque ${level}/5`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <span key={i} className={`h-1.5 w-3 rounded-full ${i <= level ? activeColor : "bg-slate-200"}`} />
      ))}
    </div>
  );
}

export default function ProjectCard({ p }) {
  return (
    <Link to={`/projets/${p.id}`} data-testid={`project-card-${p.id}`}
      className="group block bg-white rounded-xl border border-slate-200 overflow-hidden hover:shadow-md hover:border-congo-blue/30 transition-all duration-200">
      <div className="relative h-44 overflow-hidden bg-slate-100">
        <img src={p.image_url || FALLBACK_IMG} alt={p.title} loading="lazy"
          className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300" />
        <div className="absolute inset-0 bg-slate-900/10" />
        <Badge className={`absolute top-3 left-3 border-0 ${sectorColors[p.sector] || "bg-slate-100 text-slate-700"}`}>{p.sector}</Badge>
        {p.progress_pct >= 100 && <Badge className="absolute top-3 right-3 bg-green-600 text-white border-0">Financé</Badge>}
      </div>
      <div className="p-4 space-y-3">
        <div>
          <h3 className="font-head font-semibold text-slate-900 leading-snug line-clamp-2">{p.title}</h3>
          <p className="text-sm text-slate-500 flex items-center gap-1 mt-1"><MapPin className="h-3.5 w-3.5" />{p.location}</p>
        </div>
        <p className="text-sm text-slate-600 line-clamp-2">{p.short_desc}</p>
        <div>
          <div className="flex justify-between text-xs mb-1">
            <span className="font-semibold text-slate-900">{money(p.amount_collected)}</span>
            <span className="text-slate-500">{p.progress_pct}%</span>
          </div>
          <Progress value={p.progress_pct} className="h-2" />
          <p className="text-xs text-slate-400 mt-1">Objectif {money(p.funding_goal)}</p>
        </div>
        <div className="flex items-center justify-between pt-2 border-t border-slate-100 text-xs text-slate-600">
          <span className="flex items-center gap-1 text-congo-blue font-semibold"><TrendingUp className="h-3.5 w-3.5" />{p.interest_rate}% / an</span>
          <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" />{p.duration_months} mois</span>
          <span className="flex items-center gap-1"><Users className="h-3.5 w-3.5" />{p.investors_count}</span>
          <Risk level={p.risk_level} />
        </div>
      </div>
    </Link>
  );
}
